export const carSelect = function () {
  return {
    selection: true,
    page: true,
    index: true,
    indexLabel: "序号",
    column: [
      {
        label: "车牌号",
        prop: "plateCode",
        clearable: true
      }
    ]
  };
};
